<template>
    <div class="register-container full-height sm-p-t-30">
      <div class="d-flex justify-content-center flex-column full-height ">
        <div class="text-center">
          <div class="abs-logo paddme2">
            <img src="/static/img/custom/qubit-blue-logo.png" width="180" />
          </div>
        </div>

        <div class="text-center birdmob">
          <img src="/static/img/custom/bird.gif" width="500" />
        </div>

        <h3 class="text-center">The Next Generation Stamp System</h3>
        <p class="text-center">
          QuBit Stamp is an electronic stamp that can be used for postal purposes, philately, document verification and the denotion of receipts and instruments.
        </p>

        <div class="row justify-content-center paddme">
          <div class="col-sm-8">
            <div class="row m-t-10">
              <div class="col-6">
                <a href="https://play.google.com/store/apps/details?id=com.imaxinacion.nipost.qubit">
                  <img
                    src="/static/img/custom/play-store.png"
                    width="100%"
                    height=""
                  />
                </a>
              </div>
              <div class="col-6">
              <a href="https://apps.apple.com/ng/app/nipost-qubit/id1477681785">
                <img
                  src="/static/img/custom/app-store.png"
                  width="100%"
                  height=""
                />
                </a>
              </div>
            </div>

            <p class="text-center">
              <br />
              Take me to <br />
              <a href="javascript:;" @click="setMobileDesk"> Desktop version </a>
            </p>
          </div>
        </div>
      </div>
    </div>

</template>

<script>

var pageMethods = {
    setMobileDesk() {
        localStorage.mobileDesk = true;
        window.location = "/auth/login";
    }
}

export default {
    name: "MobileState",
    data() {
        return {
            mobileDesk: false,
        };
    },
    mounted() {
        if (localStorage.mobileDesk) {
            console.log('Set');
            window.location = "/auth/login";
        }
    },
    watch: {
        mobileDesk(zSet) {
            localStorage.mobileDesk = zSet;
        }
    },
    methods: pageMethods
}
</script>